import { css } from "@emotion/react";

export const searchesWrapper = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
